const _ = require('lib/underscore')
const BaseModel = require('lib/base_model')
const log = require('log').create('button'); // eslint-disable-line


const Button = BaseModel.extend({

     
    constructor: function constructor(input_attrs, options) {
        let attributes = input_attrs
        if (_.isString(attributes)) {
            attributes = {
                text: attributes,
            }
        }
        BaseModel.apply(this, [attributes, options])
    },

    defaults: {
        tagName: 'button',
        type: 'button',
        default: false,
        button: true,
        size: 'large',
        loading: false,
        disabled: false,
    },

})

module.exports = Button
